import React from "react"

import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { useProductTenderTextContext } from "../ProductTenderTextContext"

export const ProductTenderTextGeneralDescription = React.memo(() => {
  const { productInformation, isLoading } = useProductTenderTextContext()

  const show = !!productInformation?.generalDescription || isLoading

  if (!show) return null

  return (
    <div className="product-tender-text__section">
      <h3 className="label label--bold">
        {isLoading ? (
          <Skeleton />
        ) : (
          productInformation?.generalDescription?.label ?? ""
        )}
      </h3>
      <p>
        {isLoading ? (
          <Skeleton count={2} />
        ) : (
          productInformation?.generalDescription?.value ?? ""
        )}
      </p>
    </div>
  )
})

ProductTenderTextGeneralDescription.displayName =
  "ProductTenderText.GeneralDescription"
